import styled from "styled-components";
import { OrderStatusTone } from "../../../helpers/order.helper";

export const Badge = styled.span<{ $tone: OrderStatusTone }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-size: 11.5px;
  font-weight: 800;
  white-space: nowrap;
  ${(p) => {
    const c = p.theme.tokens.colors;
    switch (p.$tone) {
      case "warning":
        return `background: ${c.accentOrange}22; color: ${c.accentOrange};`;
      case "info":
        return `background: ${c.softTeal}; color: ${c.teal};`;
      case "success":
        return `background: ${c.softTeal}; color: ${c.green};`;
      case "error":
        return `background: ${c.red}18; color: ${c.red};`;
      default:
        return `background: ${c.softBg}; color: ${c.muted};`;
    }
  }}
`;
